"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const generateID = (id, header) => {
  if (id) {
    return id;
  } else if (header) {
    return header.replace(" ", "-");
  } else {
    return undefined;
  }
};
var _default = generateID;
exports.default = _default;